import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6771a07f"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["data-course-id", "data-page-id", "data-part-id", "data-exposure-time"]
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "subject" }, [
  /*#__PURE__*/_createElementVNode("img", {
    "data-v-6e03f799": "",
    src: "https://asset.greedyai.com/revision/middly-study-1.png",
    alt: ""
  }),
  /*#__PURE__*/_createTextVNode(" 单选题 ")
], -1))
const _hoisted_3 = { class: "choice" }
const _hoisted_4 = ["innerHTML"]
const _hoisted_5 = { class: "options" }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = ["innerHTML"]
const _hoisted_8 = {
  key: 0,
  class: "tips"
}
const _hoisted_9 = { key: 0 }
const _hoisted_10 = {
  key: 1,
  class: "explain"
}

import {computed, ref} from "vue";
import {commitAnswer} from "@/apis/recorded";
import {PageRecord} from "@/models/page/pageRecord";
import Choice from "@/models/page/choice";
import {contentRender} from "@/lib/contentRender";


export default /*#__PURE__*/_defineComponent({
  __name: 'ChoicePage',
  props: {
    page: {},
    userPage: {},
    courseId: {},
    partId: {},
    pageId: {}
  },
  setup(__props: any) {

const props = __props

const pageData = ref<Choice>(props.page)
const userPageData = ref<PageRecord>(props.userPage)
// 用户选择
const userAnswer = ref<number | null>(userPageData.value.userAnswer ? Number(userPageData.value.userAnswer) : null)
// 重做
const redoFlag = ref<boolean>(false)
// 状态
const status = computed<'DOING' | 'WRONG' | 'RIGHT'>(
  () => userPageData.value.status != 'STUDIED' ||  redoFlag.value
    ? 'DOING'
    : userPageData.value.isRight === 'NO' ? 'WRONG' : 'RIGHT')
// 响应点击
const handleClick = (index: number) => {
  if (status.value === 'DOING' || redoFlag.value) {
    userAnswer.value = index
    commitAnswer({
      answer: index + '',
      recordedPageId: props.pageId,
      partId: props.partId,
      courseId: props.courseId
    }).then(res => {
      if (res?.code == 200 && res?.data) {
        userPageData.value = res?.data?.userPage
        pageData.value = res?.data?.page as Choice
        redoFlag.value = false
      }
    })
  }
}

const handleRedo = () => {
  redoFlag.value = true
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "exposure choice-wrap",
    "data-course-id": _ctx.courseId,
    "data-page-id": _ctx.pageId,
    "data-part-id": _ctx.partId,
    "data-exposure-time": _ctx.userPage.exposureTime
  }, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", {
        class: "question",
        innerHTML: _unref(contentRender)(pageData.value.question)
      }, null, 8, _hoisted_4),
      _createElementVNode("ul", _hoisted_5, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(pageData.value.options, (item, index) => {
          return (_openBlock(), _createElementBlock("li", {
            class: "option",
            key: 'choice'+ _ctx.pageId + '-' +index,
            onClick: ($event: any) => (handleClick(index))
          }, [
            _createElementVNode("i", {
              class: _normalizeClass({
            'el-icon-check right': userAnswer.value === index && status.value === 'RIGHT',
            'el-icon-close wrong': userAnswer.value === index && status.value === 'WRONG',
          })
            }, null, 2),
            _createElementVNode("span", {
              innerHTML: _unref(contentRender)(item)
            }, null, 8, _hoisted_7)
          ], 8, _hoisted_6))
        }), 128))
      ])
    ]),
    (status.value === 'WRONG')
      ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
          (pageData.value.tips)
            ? (_openBlock(), _createElementBlock("p", _hoisted_9, _toDisplayString(pageData.value.tips), 1))
            : _createCommentVNode("", true),
          _createElementVNode("div", {
            class: "redo-btn",
            onClick: handleRedo
          }, "重做")
        ]))
      : _createCommentVNode("", true),
    (status.value === 'RIGHT' && pageData.value.explanation)
      ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
          _createElementVNode("p", null, _toDisplayString(pageData.value.explanation), 1)
        ]))
      : _createCommentVNode("", true)
  ], 8, _hoisted_1))
}
}

})